import React, { useState, useEffect } from "react";
import { screensService } from "../services/api";
import ScreenCard from "../components/ScreenCard";

function Screens({ user }) {
  const [screens, setScreens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    loadScreens();
    const interval = setInterval(loadScreens, 5000);
    return () => clearInterval(interval);
  }, []);

  const loadScreens = async () => {
    try {
      const response = await screensService.getAll();
      setScreens(response.data);
    } catch (error) {
      console.error("Error loading screens:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredScreens = screens.filter((screen) => {
    if (filter === "online") return screen.is_online;
    if (filter === "offline") return !screen.is_online;
    return true;
  });

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="screens-page">
      <div className="page-header">
        <h1>Gestion des ecrans</h1>
        <div className="filters">
          <button
            className={filter === "all" ? "active" : ""}
            onClick={() => setFilter("all")}
          >
            Tous ({screens.length})
          </button>
          <button
            className={filter === "online" ? "active" : ""}
            onClick={() => setFilter("online")}
          >
            En ligne ({screens.filter((s) => s.is_online).length})
          </button>
          <button
            className={filter === "offline" ? "active" : ""}
            onClick={() => setFilter("offline")}
          >
            Hors ligne ({screens.filter((s) => !s.is_online).length})
          </button>
        </div>
      </div>

      <div className="screens-list">
        {filteredScreens.map((screen) => (
          <div key={screen.id} className="screen-list-item">
            <div
              className={`screen-list-row ${screen.is_online ? "online" : "offline"} ${selectedId === screen.id ? "selected" : ""}`}
              onClick={() => setSelectedId(selectedId === screen.id ? null : screen.id)}
            >
              <div className="screen-list-status">
                <span className={`status-dot ${screen.is_online ? "online" : "offline"}`}></span>
              </div>
              <div className="screen-list-name">{screen.name}</div>
              <div className="screen-list-pi">{screen.pi_id}</div>
              <div className="screen-list-tv">
                TV: {screen.tv_power === "on" ? "Allumee" : screen.tv_power === "off" ? "Eteinte" : "Inconnu"}
              </div>
              <div className="screen-list-temp">
                {screen.cpu_temp ? screen.cpu_temp.toFixed(1) + "C" : "--"}
              </div>
              <div className="screen-list-status-text">
                {screen.is_online ? "En ligne" : "Hors ligne"}
              </div>
              <div className="screen-list-arrow">
                {selectedId === screen.id ? "\u25B2" : "\u25BC"}
              </div>
            </div>
            {selectedId === screen.id && (
              <div className="screen-detail-panel">
                <ScreenCard screen={screen} onRefresh={loadScreens} detailed />
              </div>
            )}
          </div>
        ))}
      </div>

      {filteredScreens.length === 0 && (
        <div className="empty-state">
          <p>Aucun ecran dans cette categorie.</p>
        </div>
      )}
    </div>
  );
}

export default Screens;
